//@flow
import {
  // DELETE_REVIEW,
  // DELETE_REPLY,
  STORE_REVIEWS,
  RESET_REVIEWS,
  UPDATE_REVIEW,
  UPDATE_REPLY,
  UPDATED,
} from '../actions/types';

const initialState = {
  reviews: [],
  onUpdated: false,
};

//although most of the action types returns the same object.
//the api can change, no need to refactor now.

export default (state = initialState, action) => {
  const { reviews, review } = action;

  switch (action.type) {
    case STORE_REVIEWS:
      return { ...state, reviews: [...reviews] };

    case UPDATE_REVIEW:
      return { ...state, reviews: [...review], onUpdated: true };

    case UPDATE_REPLY:
      return { ...state, reviews: [...review], onUpdated: true };

    case UPDATED:
      return { ...state, onUpdated: false };

    case RESET_REVIEWS:
      return { ...initialState };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/reviewsReducer.js